/** 发布订阅 - 原本shopify模板自带 */
globalThis.PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    optionValueSelectionChange: 'option-value-selection-change',
    variantChange: 'variant-change',
    cartError: 'cart-error'
}

globalThis.subscribers = {}

globalThis.subscribe = function (eventName, callback) {
    if (subscribers[eventName] === undefined) {
        subscribers[eventName] = []
    }

    subscribers[eventName] = [...subscribers[eventName], callback]

    return function unsubscribe() {
        subscribers[eventName] = subscribers[eventName].filter((cb) => {
            return cb !== callback
        })
    }
}

globalThis.publish = function (eventName, data) {
    if (subscribers[eventName]) {
        const promises = subscribers[eventName]
            .map((callback) => callback(data))
        return Promise.all(promises)
    } else {
        return Promise.resolve()
    }
}